module.exports = __webpack_public_path__ + "img/pc_banner_sup_responsible.6f89b806.webp";